export const SET_USUARIOS = 'SET_USUARIOS';
export const LOAD_USUARIOS_PAGE = 'LOAD_USUARIOS_PAGE';
export const LOAD_USUARIOS_PERPAGE = 'LOAD_USUARIOS_PERPAGE';
export const LOAD_USUARIOS_TOTAL = 'LOAD_USUARIOS_TOTAL';
export const LOAD_FILTRO = 'LOAD_FILTRO';
export const LOADING_USUARIOS = 'LOADING_USUARIOS';
export const SET_USUARIOS_LIST = 'SET_USUARIOS_LIST';
export const DADOS_PESSOAIS_SET = 'DADOS_PESSOAIS_SET';
export const LOAD_USUARIOS_PERMISSAO = 'LOAD_USUARIOS_PERMISSAO';
export const LOADING_RESET_SENHA = 'LOADING_RESET_SENHA';